// 会员状态

<template>
  <Card title="会员状态">
    <template slot="content">
      <div class="content">
        <div class="tip">
          到期时间:
          测试永久
          <!-- <span class="value green" v-if="vipState">{{
            userInfo.deadTime | timeFormatter
          }}</span>
          <span class="value red" v-else
            >{{ userInfo.deadTime | timeFormatter }} 已到期</span
          > -->
        </div>
        <div class="goBuy-btn-box">
          <MButton class="goBuy-btn" @click="GoBuy">前往续费</MButton>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from "@/components/common/Card";
import MButton from "@/components/common/Button.vue";
export default {
  components: {
    Card,
    MButton,
  },
  computed: {
    userInfo: function () {
      return this.$store.getters.getUserInfo;
    },
    vipState: function () {
      return new Date(this.$store.getters.getUserInfo.deadTime) > new Date();
    },
  },
  methods: {
    GoBuy() {
      this.$router.push({ name: "Buy" });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .value {
    display: inline-block;
  }
  .green {
    color: green;
  }
  .red {
    color: red;
  }
  .goBuy-btn-box {
    width: 50%;
    margin: 0 auto;
  }
  .goBuy-btn {
    background: #5932ea;
    color: #fff;
    &:hover {
      filter: brightness(1.2);
    }
  }
}
</style>
